import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { STATSTYPE_INIT_LOADING, STATSTYPE_INIT_SUCCESS, STATSTYPE_INIT_FAIL } from '@/store/types'

const state = {
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [STATSTYPE_INIT_LOADING](state, err) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [STATSTYPE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [STATSTYPE_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async statsTypeManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.statsTypeManagement
    commit(STATSTYPE_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(STATSTYPE_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(STATSTYPE_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
